<template>
  <div class="document-tile-view">
    <document-to-review
      v-for="(document, index) in documentData.displayDocuments"
      :key="index"
      :title="document.displayDocumentDescription"
      :link="document.displayDocumentPath"
      :num="0"
      :markOpened="false"
      :showLabel="documentData.settingsShowOpenStatus === 1"
    >
      <template v-slot:suffix>
        <span>
          {{ document.displayDocumentTitle }}
        </span>
      </template>
    </document-to-review>
  </div>
</template>

<script src="./document-tile-view.js"></script>
<style src="./document-tile-view.scss" lang="scss"></style>
